import "./public-path";
import { render } from "react-dom";
import './styles.css'
import './styles.scss'
import App from "./App";

const rootElement = document.getElementById("root");
render(<App />, rootElement);
